export default __webpack_public_path__ + "static/media/t13.min.1f1d46a9.png";